<div class="background-login d-flex align-items-center justify-content-center">
  <div class="container-fluid" style="height: 100%; padding: 0">
    <div class="align-items-center justify-content-center" style="height: 100%">
      <div style="width: 100%; height: 100%">
        <div style="width: 100%; height: 100%; display: flex">
          <div
            style="
              flex: 0.4;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
          >
            <div class="content-login">
              <img src="assets/icons/loginLogo.svg" style="width: 7em" alt="" />

              <h1 class="login-title">{{ "LoginGreeting" | translate }}</h1>

              <p class="login-subtitle">
                {{ "LoginSubtitle" | translate }}
              </p>
              <form [formGroup]="loginForm" class="login-form">
                <div class="login-form-item form-group">
                  <label class="login-form__label" for="email">
                    {{ "LoginFormEmailLabel" | translate }}
                  </label>
                  <input
                    id="email"
                    emailValidation
                    type="email"
                    [class.is-invalid]="
                      loginForm.get('email').invalid &&
                      loginForm.get('email').touched
                    "
                    class="login-form-input form-control"
                    placeholder="Insira seu email"
                    name="email"
                    required
                    formControlName="email"
                  />
                  <div
                    *ngIf="
                      (loginForm.get('email').invalid &&
                        loginForm.get('email').touched) ||
                      loginForm.get('email').dirty
                    "
                    class="message-wrapper"
                  >
                    <span
                      *ngIf="loginForm.get('email').errors?.required"
                      class="text-danger"
                    >
                      {{ "LoginFormEmailMissingWarning" | translate }}
                    </span>
                    <span
                      *ngIf="loginForm.get('email').errors?.email"
                      class="text-danger"
                    >
                      {{ "LoginFormEmailInvalidWarning" | translate }}
                    </span>
                    <span
                      *ngIf="loginForm.get('email').errors?.uniqueEmail"
                      class="text-danger"
                    >
                      {{ "LoginFormEmailUsedWarning" | translate }}
                    </span>
                  </div>
                </div>
                <div class="login-form-item form-group">
                  <label class="login-form__label" for="password">
                    {{ "LoginFormPasswordLabel" | translate }}
                  </label>
                  <div
                    class="input-group input-group__password position-relative"
                  >
                    <input
                      [type]="fieldTextType ? 'text' : 'password'"
                      id="password"
                      type="password"
                      [class.is-invalid]="
                        loginForm.get('password').invalid &&
                        loginForm.get('password').touched
                      "
                      style="
                        border-end-end-radius: 16px;
                        border-top-right-radius: 16px;
                      "
                      class="login-form-input form-control"
                      placeholder="Insira sua senha"
                      name="password"
                      required
                      formControlName="password"
                    />
                    <button
                      type="button"
                      class="btn-icon"
                      (click)="toggleFieldTextType()"
                      style="
                        position: absolute;
                        right: 0;
                        height: 100%;
                        z-index: 100;
                        border: none;
                        background: none;
                        border-end-end-radius: 16px;
                        border-top-right-radius: 16px;
                        padding-right: 12px;
                      "
                    >
                      <img
                        [src]="
                          fieldTextType
                            ? 'assets/icons/openEye.svg'
                            : 'assets/icons/closedEye.svg'
                        "
                        alt=""
                      />
                    </button>
                  </div>
                  <div
                    *ngIf="
                      (loginForm.get('password').invalid &&
                        loginForm.get('password').touched) ||
                      loginForm.get('password').dirty
                    "
                    class="message-wrapper"
                  >
                    <span
                      *ngIf="loginForm.get('password').errors?.required"
                      class="text-danger"
                    >
                      {{ "LoginFormPasswordMissingWarning" | translate }}
                    </span>
                  </div>
                  <div class="forgot-password" style="margin-top: 12px">
                    <a
                      class="redirect-text"
                      routerLink="/forgot-password"
                      style="margin-top: -0.6rem"
                    >
                      {{ "LoginFormForgotPassword" | translate }}
                    </a>
                  </div>
                </div>
                <div class="login-button-container">
                  <button
                    id="btn-login"
                    type="submit"
                    [disabled]="!loginForm.valid"
                    ref=""
                    class="btn-custom"
                    (click)="!logging && signIn()"
                  >
                    <div *ngIf="!logging" style="text-transform: uppercase">
                      {{ "LoginFormSubmitButton" | translate }}
                    </div>
                    <div class="button-spinner" *ngIf="logging">
                      <mat-spinner
                        class="button-spinner"
                        [diameter]="20"
                      ></mat-spinner>
                    </div>
                  </button>

                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      position: relative;
                      margin: 0.5rem 0 0.25rem;
                    "
                  >
                    <hr style="border-top: 1px solid #c5c0d6; width: 100%" />

                    <div
                      style="
                        position: absolute;
                        color: #48464a;
                        background-color: white;
                        padding: 0 0.5rem;
                      "
                    >
                      {{ "LoginFormTrialText" | translate }}
                    </div>
                  </div>

                  <button
                    id="btn-trial"
                    type="submit"
                    class="btn-success"
                    (click)="!logging && trialSignIn()"
                  >
                    <div *ngIf="!logging">
                      {{ "LoginFormTrialButton" | translate }}
                    </div>
                    <div class="button-spinner" *ngIf="logging">
                      <mat-spinner
                        class="button-spinner"
                        [diameter]="20"
                      ></mat-spinner>
                    </div>
                  </button>
                </div>

                <div class="political-group">
                  <a class="redirect-text" routerLink="/privacy-policy">{{
                    "LoginPrivacyPolicyLink" | translate
                  }}</a>
                  <a class="redirect-text" routerLink="/terms-and-conditions">{{
                    "LoginTermsOfUse" | translate
                  }}</a>
                </div>
              </form>
              <a
                style="text-align: center"
                class="redirect-text"
                href="https://portal.superninamob.com/contact"
                target="_blank"
                >{{ "LoginContactNinaLink" | translate }}</a
              >
            </div>
          </div>

          <div
            class=""
            style="flex: 0.6; background-color: black; overflow: hidden"
          >
            <ngb-carousel
              class="carousel-fade"
              #carousel
              [interval]="3000"
              [showNavigationArrows]="false"
            >
              <ng-template ngbSlide>
                <div
                  class="imagem-carrousel background-one"
                  style="text-align: center"
                >
                  <img
                    src="assets/icons/login-bar.svg"
                    style="
                      position: absolute;
                      width: 90%;
                      height: 80%;
                      right: 0;
                    "
                    alt=""
                  />
                  <img
                    src="assets/icons/nina-pose.svg"
                    style="height: 90%; position: absolute"
                    alt=""
                  />
                </div>
              </ng-template>
              <ng-template ngbSlide>
                <div
                  class="imagem-carrousel background-two"
                  style="text-align: center"
                >
                  <h2
                    style="
                      color: var(--material-theme-sys-light-on-primary, #fff);
                      font-family: Roboto;
                      font-size: 40px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 64px;
                      padding: 0;
                      margin: 0;
                      width: 70%;
                      text-align: left;
                    "
                  >
                    {{ "LoginSlidesGetNinaTitle" | translate }}
                  </h2>
                  <h3
                    style="
                      color: #fff;
                      /* Headline/Medium */
                      font-family: Roboto;
                      font-size: 20px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 36px;
                      padding: 0;
                      margin: 0;
                      text-align: left;
                      max-width: 80%;
                    "
                  >
                    {{ "LoginSlidesGetNinaText" | translate }}
                  </h3>
                  <div
                    style="
                      display: flex;
                      width: 100%;
                      justify-content: center;
                      height: 100%;
                      align-items: flex-end;
                      padding-bottom: 20px;
                    "
                  >
                    <a
                      style="
                        display: flex;
                        width: 362px;
                        padding: 24px;
                        height: 55px;
                        justify-content: center;
                        align-items: center;
                        gap: var(--corner-16, 16px);
                        border-radius: 40px;
                        background: var(
                          --material-theme-ref-tertiary-tertiary-70,
                          #3abfa2
                        );
                        color: var(--material-theme-sys-light-on-primary, #fff);
                        text-align: center;
                        font-family: Roboto;
                        font-size: 22px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 28px;
                        border: none;
                      "
                      href="https://portal.superninamob.com/contact"
                      target="_blank"
                    >
                      {{ "LoginSlidesGetNinaButton" | translate }}
                    </a>
                  </div>
                </div>
              </ng-template>
              <ng-template ngbSlide>
                <div
                  class="imagem-carrousel background-three"
                  style="text-align: center"
                >
                  <h2
                    style="
                      color: var(--material-theme-sys-light-on-primary, #fff);
                      font-family: Roboto;
                      font-size: 40px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 64px;
                      padding: 0;
                      margin: 0;
                      width: 70%;
                      text-align: left;
                    "
                  >
                    {{ "LoginSlidesSafeCitiesTitle" | translate }}
                  </h2>
                  <h3
                    style="
                      color: #fff;
                      /* Headline/Medium */
                      font-family: Roboto;
                      font-size: 20px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 36px;
                      padding: 0;
                      margin: 0;
                      text-align: left;
                      max-width: 80%;
                    "
                  >
                    {{ "LoginSlidesSafeCitiesText" | translate }}
                  </h3>
                  <div
                    style="
                      display: flex;
                      width: 100%;
                      justify-content: center;
                      align-items: flex-end;
                      padding-bottom: 20px;
                      padding-top: 40px;
                    "
                  >
                    <button
                      style="
                        display: flex;
                        width: 362px;
                        padding: 24px;
                        height: 55px;
                        justify-content: center;
                        align-items: center;
                        gap: var(--corner-16, 16px);
                        border-radius: 40px;
                        background: var(
                          --material-theme-ref-tertiary-tertiary-70,
                          #5b43d9
                        );
                        color: var(--material-theme-sys-light-on-primary, #fff);
                        text-align: center;
                        font-family: Roboto;
                        font-size: 22px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 28px;
                        border: none;
                      "
                    >
                      {{ "LoginSlidesSafeCitiesButton" | translate }}
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngb-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
